<template>

<div class='menu-wrapper'>
  <button id='mobile-menu' v-on:click='toggleMenu'>
    <span id='mobile-menu-icon' class="icon-navicon"></span>
  </button>

  <transition name="fade">
    <nav role='navigation' v-show="open">
      <ul>
        <li>
            <router-link @click.native="toggleMenu" :to="{ path: '/'}" exact>Home / Search</router-link>
        </li>
        <li>
            <router-link @click.native="toggleMenu" :to="{ path: '/a-z/'}" exact>A-Z by Country</router-link>
        </li>
        <li>
            <router-link @click.native="toggleMenu" :to="{ path: '/contact/'}" exact>Contact</router-link>
        </li>
      </ul>
    </nav>
  </transition>
</div>

</template>

<script>

export default {
  data: function () {
    return {
      open: false
    }
  },
  methods: {
    toggleMenu: function(event) {
      this.open = ! this.open;
    }
  }
}

</script>
